__turbopack_context__.v({
  "container": "LandingPageContainer-module-scss-module__ya8z8a__container",
  "pageWrapper": "LandingPageContainer-module-scss-module__ya8z8a__pageWrapper",
});
